import { render, staticRenderFns } from "./BusinessLocationDetails.vue?vue&type=template&id=080db5d2"
import script from "./BusinessLocationDetails.vue?vue&type=script&setup=true&lang=js"
export * from "./BusinessLocationDetails.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports